import React from "react"
import styled from "styled-components"
import { LinkExternal, theme } from "@op-str/op-component-library"
import { HelpPageSchema } from "../../types/HelpPageSchema"
import PhoneEnabledOutlinedIcon from "@mui/icons-material/PhoneEnabledOutlined"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"

export type HelpFooterProps = {
  pageResult?: HelpPageSchema
}

export const HelpFooter = (props: HelpFooterProps) => {
  const { pageResult } = props

  return pageResult ? (
    <Footer>
      <Title>{pageResult.fields.help_footer.title}</Title>
      <LargeVerticalSpacer />
      <ContactInfo>
        <PhoneEnabledOutlinedIcon /> <span>{pageResult.fields.help_footer.phone_number}</span>
      </ContactInfo>
      <VerticalSpacer />
      <ContactInfo>
        <EmailOutlinedIcon />{" "}
        <LinkExternal
          label={pageResult.fields.help_footer.email}
          link={`mailto:${pageResult.fields.help_footer.email}`}
        />
      </ContactInfo>
    </Footer>
  ) : (
    <></>
  )
}

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${theme.color.white2};
  padding: ${theme.spacing.xxl};
`

const Title = styled.div`
  font-size: ${theme.fontSize.xxl};
  line-height: ${theme.lineHeight.l};
  font-family: ${theme.font.bold};
`

const ContactInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.m};
  font-size: ${theme.fontSize.m};
  line-height: ${theme.lineHeight.m};

  a {
    font-family: ${theme.font.bold};
    color: ${theme.color.primary};
    text-decoration: none;
  }
`

const VerticalSpacer = styled.div`
  height: ${theme.spacing.l};
`

const LargeVerticalSpacer = styled.div`
  height: ${theme.spacing.xl};
`
